export const types = <const>{
	mutations: {
		ND_OBJEDNAVKA_ZAKAZKA_ZAKAZKA_MAPPER: 'ND_OBJEDNAVKA_ZAKAZKA_ZAKAZKA_MAPPER',
	},
};
